var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blog-post-page"},[_c('OBlogPost'),(!_vm.isAuthenticated)?_c('MConversionBanner'):_vm._e(),_c('TheFooter',{attrs:{"is-authenticated":_vm.isAuthenticated}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }